export const API_URL = localStorage.getItem('stubbornParams') || process.env.REACT_APP_API_URL || 'http://localhost:9099';
